// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"261":"58ae941b","296":"e708bff3","617":"91eb47c4","930":"b61c2051","981":"1e6a5faf"}[chunkId] + ".chunk.js";
};